export const BoddRole = 'Bodd';
export const BoddLimitedRole = 'BoddLimited';
export const QualityAssuranceRole = 'QualityAssurance';
export const MerchantRole = 'Merchant';
export const MerchantAdminRole = 'MerchantAdmin';
export const MerchantOwnerRole = 'MerchantOwner';
export const SystemOwnerRole = 'SystemOwner';
